import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'

import { environment } from '../../environments/environment'
import { TicketGroup, TicketGroupUpdateDTO } from "../_models/ticket-group.interface";

@Injectable({
  providedIn: 'root'
})
export class TicketGroupService {

  constructor(
    private http: HttpClient
  ) {
  }

  public update(id: number, params: TicketGroupUpdateDTO) {
    const path = environment.apiURL + 'ticket_groups/' + id

    return this.http.patch<TicketGroup>(path, { params })
  }

  public delete(id: number) {
    const path = environment.apiURL + 'ticket_groups/' + id

    return this.http.delete<void>(path)
  }

  public uniteGroups(id: number, target_group_id: number) {
    const path = environment.apiURL + 'ticket_groups/' + id + '/unite_group'

    return this.http.post<TicketGroup>(path, { target_group_id })
  }
}
